export const CREATE_BILL = 'createBill';
export const FETCH_BILL_BY_ID = 'fetchBillById';
export const UPDATE_BILL = 'updateBill';
export const FETCH_ORGANIZATION_BILLS = 'fetchOrganizationBills';
export const FETCH_BILLS_BY_COST_ID = 'fetchBillsByCostId';
export const UPDATE_BILL_STATUS_BY_BILL_ID = 'updateBillStatusByBillId';
export const FETCH_USER_BILLS = 'fetchUserBills';
